import React from "react";

import Header from "../components/header";
import Footer from "../components/footer";
import Whatsapp from "../components/whatsapp";

import "../style/privacyTerms.css";

function PrivacyTerms() {
    return (
        <React.Fragment>
            <Header />
            
            <div className="terms-container">
                <div className="header">
                    <b>Termos de Privacidade</b>
                </div>

                <div className="content">
                    <b>Coleta de Dados</b>
                    <span>Login: e-mail, senha cadastrada e informações do dispositivo (marca, modelo e sistema operacional). <br />Acesso ao aplicativo: endereço IP e atividades de navegação entre conteúdos. <br />Logs de erros: dados sobre falhas enviadas ao servidor para aprimorar os serviços.</span>

                    <b>Finalidade da Coleta</b>
                    <span>Melhorias da plataforma: compreender a utilização e desenvolver melhorias. <br />Comercial: personalizar conteúdo e melhorar a qualidade dos serviços. <br />Cadastro: permitir acesso a conteúdos exclusivos para usuários registrados. <br />Contrato:  conferir segurança jurídica e facilitar a conclusão de negócios. <br />Qualquer tratamento de dados para finalidades não previstas será previamente comunicado ao usuário.</span>
                
                    <b>Tempo de Armazenamento</b>
                    <span>Os dados pessoais são armazenados pelo tempo necessário para a prestação do serviço ou cumprimento das finalidades, podendo ser removidos ou anonimizados a pedido do usuário, exceto nos casos previstos em lei. <br />Conforme o artigo 16 da Lei 13.709/18, os dados poderão ser conservados para: <br />Cumprimento de obrigação legal ou regulatória; <br />Estudos de pesquisa, com anonimização sempre que possível; <br />Transferência a terceiros respeitando os requisitos legais; <br />Uso exclusivo do controlador, com anonimização.</span>
                
                    <b>Segurança dos Dados</b>
                    <span>A plataforma aplica medidas técnicas e organizativas para proteger os dados pessoais contra acessos não autorizados, destruição, perda, alteração ou difusão. <br />Os dados são criptografados com tecnologia SSL (Secure Socket Layer), garantindo transmissão segura e confidencial. <br />A empresa se compromete a comunicar violações de segurança, mas não se responsabiliza por culpa exclusiva de terceiros (como ataques hackers) ou do próprio usuário.</span>

                    <b>Consentimento</b>
                    <span>Ao utilizar os serviços e fornecer informações, o usuário consente com esta Política de Privacidade. Ele pode a qualquer momento exercer seus direitos de atualização, cancelamento ou retirada do consentimento através da Central de Relacionamento.</span>

                    <b>Alterações na Política</b>
                    <span>A Política de Privacidade pode ser modificada a qualquer momento. As alterações entram em vigor após publicação e os usuários serão notificados. Em caso de fusão ou venda da empresa, os dados poderão ser transferidos aos novos proprietários. <br />Esta política é efetiva a partir de agosto de 2023.</span>
                
                    <b>Jurisdição</b>
                    <span>A Política de Privacidade pode ser modificada a qualquer momento. As alterações entram em vigor após publicação e os usuários serão notificados. Em caso de fusão ou venda da empresa, os dados poderão ser transferidos aos novos proprietários. <br />Esta política é efetiva a partir de agosto de 2023.</span>
                </div>
            </div>

            <Whatsapp/>
            <Footer />
        </React.Fragment>
    )
}

export default PrivacyTerms;